/**
 * Shared utilities for chess UI components
 */

export { FILES, isLightSquare, RANKS } from "./board-constants";
export { getPieceSymbol, PIECE_SYMBOLS } from "./piece-symbols";
